import { render, staticRenderFns } from "./LinkAccount.vue?vue&type=template&id=a5cb815a&scoped=true&"
import script from "./LinkAccount.vue?vue&type=script&lang=js&"
export * from "./LinkAccount.vue?vue&type=script&lang=js&"
import style0 from "./LinkAccount.vue?vue&type=style&index=0&id=a5cb815a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cb815a",
  null
  
)

export default component.exports